import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

function LocalityBarChart({ data }) {
  const rows = [...(data || [])].sort((a, b) => b.count - a.count);

  if (rows.length === 0) {
    return <p className="flex h-48 items-center justify-center text-sm text-slate-400">Sem dados no período.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={rows.length * 44 + 20}>
      <BarChart data={rows} layout="vertical" margin={{ top: 0, right: 16, left: 8, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#e2e8f0" />
        <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11, fill: '#94a3b8' }} axisLine={false} tickLine={false} />
        <YAxis type="category" dataKey="locality" width={110} tick={{ fontSize: 12, fill: '#475569' }} axisLine={false} tickLine={false} />
        <Tooltip formatter={(value) => [`${value} notícias`, 'Total']} />
        <Bar dataKey="count" fill="#6366f1" radius={[0, 6, 6, 0]} barSize={20} />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default LocalityBarChart;
